import { Navigate, useLocation } from "react-router-dom";
import {
  AUTOMOTIVE_SECTION_REDIRECTS,
  TRANSPORT_BASE_PATH,
  transportPathForSection,
} from "../../../constants/transport";

/** Legacy /automotive/* URLs → merged /transport/* mobility routes. */
const AutomotivePathRedirect = () => {
  const location = useLocation();
  const remainder = location.pathname.replace(/^\/automotive\/?/, "");
  const segment = remainder.split("/")[0] || "dashboard";
  const section = AUTOMOTIVE_SECTION_REDIRECTS[segment] || AUTOMOTIVE_SECTION_REDIRECTS.dashboard;
  const target = transportPathForSection(section);
  const suffix = location.search || "";
  const hash = location.hash || "";
  return <Navigate to={`${target}${suffix}${hash}`} replace />;
};

export default AutomotivePathRedirect;
